import { useState, useEffect } from "react";
import {Link, useNavigate } from "react-router-dom";
import mkcgLogo from "../assests/logo/logo.png";
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

const EyeIcon = ({ open }) =>
  open ? (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  ) : (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );

/* ── Main component ────────────────────────────────────────────────────── */
export default function ResetPassword() {
  // The reset token was stashed in sessionStorage by ForgotPassword after
  // a successful identity check — this stands in for the PHP's
  // $_SESSION['reset_email'].

  const navigate = useNavigate();
  const [resetToken] = useState(() => sessionStorage.getItem("resetToken") || "");

  const [password, setPassword]               = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPw, setShowPw]                   = useState(false);
  const [showConfirmPw, setShowConfirmPw]     = useState(false);
  const [errors, setErrors]                   = useState({});
  const [loading, setLoading]                 = useState(false);
  const [success, setSuccess]                 = useState(false);

  // No token means there's nothing to reset — same intent as the PHP's
  // "if (!isset($_SESSION['reset_email'])) redirect to student_login.php".
 useEffect(() => {
  if (!resetToken) {
    navigate("/student-login", { replace: true });
  }
}, [resetToken, navigate]);

  // const validate = () => {
  //   const e = {};
  //   if (!password) e.password = "Password is required.";
  //   else if (password.length < 6) e.password = "Password must be at least 6 characters.";

  //   if (!confirmPassword) e.confirmPassword = "Please confirm your password.";
  //   else if (password && confirmPassword !== password) e.confirmPassword = "Passwords do not match.";

  //   return e;
  // };
  const validate = () => {
  const e = {};

  if (!password) {
    e.password = "Password is required.";
  } else if (password.length < 6 || password.length > 8) {
    e.password =
      "6-8 characters with Uppercase, Lowercase & Special character.";
  } else if (!/[A-Z]/.test(password)) {
    e.password =
      "Password must contain at least one uppercase letter.";
  } else if (!/[a-z]/.test(password)) {
    e.password =
      "Password must contain at least one lowercase letter.";
  } else if (!/[^A-Za-z0-9]/.test(password)) {
    e.password =
      "Password must contain at least one special character.";
  }

  if (!confirmPassword) {
    e.confirmPassword = "Please confirm your password.";
  } else if (password && confirmPassword !== password) {
    e.confirmPassword = "Passwords do not match.";
  }

  return e;
};

  const handleChange = (field, val) => {
    if (field === "password") setPassword(val);
    if (field === "confirmPassword") setConfirmPassword(val);
    if (errors[field] || errors.form) {
      setErrors(p => ({ ...p, [field]: undefined, form: undefined }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({});

    const errs = validate();
    if (Object.keys(errs).length) {
      setErrors(errs);
      return;
    }

    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/student/forgot-password/reset`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${resetToken}`,
        },
        body: JSON.stringify({ password, confirmPassword }),
      });
      const data = await response.json();
      setLoading(false);

     if (data.success) {
        sessionStorage.removeItem("resetToken");
        setSuccess(true);

        setTimeout(() => {
            navigate("/StudentLogin ", { replace: true });
        }, 1500);
        } else {
        setErrors({ form: data.message || "Something went wrong. Please try again later." });
      }
    } catch (err) {
      setLoading(false);
      console.error(err);
      setErrors({ form: "Cannot connect to server. Please try again." });
    }
  };

  return (
    <>
      <style>{css}</style>
      <div className="ig-page">
      
              {/* ───────────────── TOP NAVBAR ───────────────── */}
              <header className="ig-navbar">
      
                <div className="ig-navbar-left">
      
                  <img
                    className="logo-image"
                    src={mkcgLogo}
                    alt="MKCG Medical College"
                  />
      
                  <div className="ig-navbar-titles">
      
                    <h1 className="ig-navbar-title">
                      MKCG MEDICAL COLLEGE, BERHAMPUR, ODISHA, INDIA
                    </h1>
      
                    <p className="ig-navbar-subtitle">
                      ମହାରାଜା କୃଷ୍ଣଚନ୍ଦ୍ର ଗଜପତି ଭେଷଜ ମହାବିଦ୍ୟାଳୟ, ବ୍ରହ୍ମପୁର, ଓଡ଼ିଶା, ଭାରତ
                    </p>
      
                  </div>
                </div>
      
                <div className="ig-navbar-right">
      
                  <span className="ig-navbar-badge">
                    STUDENT INTERFACE
                  </span>
      
                  <Link
                    to="/"
                    className="ig-home-btn"
                  >
                    Return to Home
                  </Link>
      
                </div>
      
              </header>

        {/* Main */}
        <main className="lp-main">
          {success ? (
            <div className="lp-card lp-success-card">
              <div className="lp-success-ring">
                <div className="lp-success-icon">✓</div>
              </div>
              <h2 className="lp-success-title">Password Reset!</h2>
              <p className="lp-success-sub">Redirecting to login…</p>
              <div className="lp-spinner-bar" />
            </div>
          ) : (
            <div className="lp-card">
              <div className="lp-card-header">
                <span>RESET PASSWORD</span>
              </div>

              <div className="lp-avatar-wrap">
                <div className="lp-avatar-ring" />
                <div className="lp-avatar">
                  <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#184381" strokeWidth="1.6">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0110 0v4" />
                  </svg>
                </div>
              </div>

              {errors.form && (
                <div className="lp-login-error">
                  <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                  {errors.form}
                </div>
              )}

              <form onSubmit={handleSubmit} noValidate className="lp-form">
                {/* Password */}
                <div className="lp-field">
                  <label className="lp-label">New Password <span>*</span></label>
                   
                  <div className={`lp-input-wrap${errors.password ? " lp-err" : ""}`}>
                    <svg className="lp-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                      <path d="M7 11V7a5 5 0 0110 0v4" />
                    </svg>
                    <input
                      type={showPw ? "text" : "password"}
                      placeholder="Enter new password"
                      value={password}
                      onChange={e => handleChange("password", e.target.value)}
                      autoComplete="new-password"
                    />
                    <button type="button" className="lp-eye" onClick={() => setShowPw(v => !v)} tabIndex={-1}>
                      <EyeIcon open={showPw} />
                    </button>
                    
                  </div>
                  <p className="sr-password-note">
                      Password must be 6-8 characters with Uppercase, Lowercase & Special character.
                    </p>
                  {errors.password && <p className="lp-error-msg">⚠ {errors.password}</p>}
                </div>

                {/* Confirm password */}
                <div className="lp-field">
                  <label className="lp-label">Confirm Password <span>*</span></label>
                  <div className={`lp-input-wrap${errors.confirmPassword ? " lp-err" : ""}`}>
                    <svg className="lp-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                      <path d="M7 11V7a5 5 0 0110 0v4" />
                    </svg>
                    <input
                      type={showConfirmPw ? "text" : "password"}
                      placeholder="Confirm new password"
                      value={confirmPassword}
                      onChange={e => handleChange("confirmPassword", e.target.value)}
                      autoComplete="new-password"
                    />
                    <button type="button" className="lp-eye" onClick={() => setShowConfirmPw(v => !v)} tabIndex={-1}>
                      <EyeIcon open={showConfirmPw} />
                    </button>
                  </div>
                  {errors.confirmPassword && <p className="lp-error-msg">⚠ {errors.confirmPassword}</p>}
                </div>

                <div className="lp-action-row lp-action-row-end">
                  <button type="submit" className="lp-submit" disabled={loading}>
                    {loading ? <span className="lp-btn-spinner" /> : "Reset Password →"}
                  </button>
                </div>
              </form>
            </div>
          )}
        </main>

        {/* Footer */}
        <footer className="lp-footer">
          <span>ALL RIGHTS RESERVED BY: MKCG MEDICAL COLLEGE 2025</span>
          <span>POWERED BY: <span className="lp-footer-brand">Orisys Infotech</span></span>
        </footer>
      </div>
    </>
  );
}

/* ── Styles (shared design system with StudentLogin.jsx / ForgotPassword.jsx) ─────────────────── */
const css = `
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&family=Noto+Sans+Odia&display=swap');

*, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

:root {
  --navy:       #184381;
  --navy-light: #2b68c3;
  --blue-glow:  #2b68c3;
  --accent:     #4a8fe0;
  --panel-border: #E4EAF3;
  --field-bg:   #F5F8FC;
  --text-primary: #0F2A44;
  --text-muted: #6B7C93;
  --error:   #E4483C;
  --success: #184381;
}

/* ═══════════════════════════════════════════════
   IMPORTANT TYPOGRAPHY
═══════════════════════════════════════════════ */

.ig-page,
.ig-page button,
.ig-page input,
.ig-page select,
.ig-page textarea {

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

}


/* Main normal text */
.ig-page {

  min-height: 100vh;

  font-size: 0.9rem;

  font-weight: 400;

  line-height: 1.5;

  color: var(--text);

  background: #EEF2F7;

}


/* ═══════════════════════════════════════════════
   TOP NAVBAR
═══════════════════════════════════════════════ */

.ig-navbar {

  display: flex;

  align-items: center;

  justify-content: space-between;

  gap: 1rem;

  background: #023c77ff;

  color: #fff;

  padding: 0.65rem 1.5rem;

  box-shadow:
    0 2px 10px rgba(0, 0, 0, 0.25);

}


.ig-navbar-left {

  display: flex;

  align-items: center;

  gap: 0.85rem;

}


.logo-image {

  height: 55px;

  width: auto;

  object-fit: contain;

}


.ig-navbar-titles {

  line-height: 1.25;

}


.ig-navbar-title {

  margin: 0;

  padding: 0;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 16px;

  font-weight: 600;

  color: #fff;

  line-height: 1.25;

  letter-spacing: 0.01em;

}


.ig-navbar-subtitle {

  margin: 2px 0 0;

  padding: 0;

  font-family:
    'Noto Sans Odia',
    sans-serif;
    font-size:14px;

  font-weight: 500;

  color:fff;

  line-height: 1.5;

}


.ig-navbar-right {

  display: flex;

  align-items: center;

  gap: 1rem;

}


.ig-navbar-badge {

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.78rem;

  font-weight: 700;

  letter-spacing: 0.05em;

  color: #E8EEF7;

}


.ig-home-btn {

  display: inline-block;

  background: #fff;

  color: #023c77ff;

  font-family:
    'Noto Sans',
    Arial,
    sans-serif;

  font-size: 0.82rem;

  font-weight: 700;

  line-height: 1.5;

  padding: 7px 16px;

  border-radius: 6px;

  text-decoration: none;

  transition:
    background 0.2s ease;

}


.ig-home-btn:hover {

  background: #DCE6F5;

  color: rgb(17, 88, 158);

}



.lp-page { min-height: 100vh; display: flex; flex-direction: column; font-family: 'Outfit', sans-serif; background: linear-gradient(160deg, #F7FAFF 0%, #FFFFFF 50%, #F2F7FF 100%); position: relative; overflow-x: hidden; }

.lp-orb { position: fixed; border-radius: 50%; filter: blur(100px); opacity: 0.30; pointer-events: none; z-index: 0; animation: orb-drift 12s ease-in-out infinite alternate; }
.lp-orb-1 { width:420px;height:420px;background:radial-gradient(circle,#CFE3FA,transparent 70%);top:-140px;left:-100px; }
.lp-orb-2 { width:350px;height:350px;background:radial-gradient(circle,#DCEBFF,transparent 70%);bottom:-100px;right:5%;animation-delay:-6s;animation-duration:15s; }
@keyframes orb-drift { 0%{transform:translate(0,0) scale(1)} 100%{transform:translate(30px,20px) scale(1.08)} }

.lp-grid { position:fixed;inset:0;background-image:linear-gradient(rgba(24,67,129,0.022) 1px,transparent 1px),linear-gradient(90deg,rgba(24,67,129,0.022) 1px,transparent 1px);background-size:60px 60px;pointer-events:none;z-index:0; }

.lp-header { position:relative;z-index:10;display:flex;align-items:center;justify-content:space-between;padding:0.6rem 2rem;background:linear-gradient(160deg,var(--navy) 0%,var(--navy-light) 100%);border-bottom:1px solid rgba(255,255,255,0.1);flex-wrap:wrap;gap:0.5rem;animation:slide-down 0.6s cubic-bezier(0.22,1,0.36,1) both; }
@keyframes slide-down { from{transform:translateY(-40px);opacity:0} to{transform:translateY(0);opacity:1} }
.lp-header-left { display:flex;align-items:center;gap:1rem; }
.lp-logo { height:52px;width:auto;filter:drop-shadow(0 0 8px rgba(24,67,129,0.35)); }
.lp-hname { font-size:0.88rem;font-weight:700;color:#fff;letter-spacing:0.02em; }
.lp-hodia { font-family:'Noto Sans Odia',sans-serif;font-size:0.72rem;color:rgba(255,255,255,0.85);margin-top:2px; }
.lp-header-right { display:flex;align-items:center;gap:0.75rem; }
.lp-interface-tag { font-size:0.78rem;font-weight:700;letter-spacing:0.1em;color:rgba(255,255,255,0.75); }
.lp-home-btn { padding:7px 18px;background:linear-gradient(90deg,var(--navy),var(--navy-light));color:#fff;font-size:0.78rem;font-weight:700;border-radius:6px;text-decoration:none;letter-spacing:0.04em;transition:filter 0.2s,transform 0.2s;box-shadow:0 2px 12px rgba(24,67,129,0.35); }
.lp-home-btn:hover { filter:brightness(1.1);transform:translateY(-1px); }

.lp-main { flex:1;display:flex;align-items:center;justify-content:center;padding:3rem 1rem;position:relative;z-index:2; }

.lp-card { width:100%;max-width:480px;background:#fff;border:1px solid var(--panel-border);border-radius:20px;overflow:hidden;box-shadow:0 8px 35px rgba(24,67,129,.16);animation:card-in 0.7s cubic-bezier(0.22,1,0.36,1) 0.1s both; }
@keyframes card-in { from{transform:translateY(30px) scale(0.97);opacity:0} to{transform:translateY(0) scale(1);opacity:1} }

.lp-card-header { background:linear-gradient(90deg,var(--navy),var(--navy-light));padding:14px 24px;text-align:center;font-size:1rem;font-weight:800;color:#fff;letter-spacing:0.12em;text-transform:uppercase;box-shadow:0 3px 16px rgba(24,67,129,.30);position:relative;overflow:hidden; }
.lp-card-header::after { content:'';position:absolute;inset:0;background:linear-gradient(90deg,transparent,rgba(255,255,255,0.15),transparent);animation:shimmer-header 3s ease infinite; }
@keyframes shimmer-header { 0%{transform:translateX(-100%)} 60%{transform:translateX(100%)} 100%{transform:translateX(100%)} }

.lp-avatar-wrap { display:flex;justify-content:center;padding:1.6rem 0 0.6rem;position:relative; }
.lp-avatar-ring { position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:100px;height:100px;border-radius:50%;background:conic-gradient(from 0deg,var(--navy),var(--navy-light),var(--navy));opacity:0.18;animation:spin-ring 5s linear infinite; }
@keyframes spin-ring { to{transform:translate(-50%,-50%) rotate(360deg)} }
.lp-avatar { width:90px;height:90px;border-radius:50%;background:#EAF1FB;border:1.5px solid #C7D6EC;display:flex;align-items:center;justify-content:center;position:relative;z-index:1;animation:logo-float 4s ease-in-out infinite; }
@keyframes logo-float { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-5px)} }

.lp-login-error { margin: 0 1.5rem 0.5rem;padding: 10px 14px;background: rgba(228,72,60,0.07);border: 1px solid rgba(228,72,60,0.25);border-radius: 10px;color: var(--error);font-size: 0.82rem;font-weight: 500;display: flex;align-items: center;gap: 8px;animation: shake 0.35s ease; }
@keyframes shake { 0%,100%{transform:translateX(0)} 25%{transform:translateX(-5px)} 75%{transform:translateX(5px)} }

.lp-form { padding:0.5rem 2rem 2rem; }
.lp-field { margin-bottom:1.1rem;animation:field-in 0.5s ease both; }
@keyframes field-in { from{opacity:0;transform:translateY(10px)} to{opacity:1;transform:translateY(0)} }
.lp-field:nth-child(1){animation-delay:0.15s}
.lp-field:nth-child(2){animation-delay:0.22s}

.lp-label { display:block;font-size:0.74rem;font-weight:600;color:var(--text-muted);letter-spacing:0.06em;text-transform:uppercase;margin-bottom:7px; }
.lp-label span { color:var(--error);margin-left:2px; }

.lp-input-wrap { display:flex;align-items:center;background:var(--field-bg);border:1px solid var(--panel-border);border-radius:10px;overflow:hidden;transition:border-color 0.25s,box-shadow 0.25s,background 0.25s; }
.lp-input-wrap:focus-within { border-color:var(--navy-light);background:#fff;box-shadow:0 0 0 3px rgba(43,104,195,.14); }
.lp-input-wrap.lp-err { border-color:var(--error);box-shadow:0 0 0 3px rgba(228,72,60,.10); }
.lp-icon { flex-shrink:0;margin-left:13px;color:#9BAABD; }
.lp-input-wrap input { flex:1;border:none;outline:none;background:transparent;color:var(--text-primary);font-size:0.9rem;font-family:'Outfit',sans-serif;padding:12px 14px; }
.lp-input-wrap input::placeholder { color:#A6B3C4; }

.lp-eye { background:none;border:none;padding:0 13px;color:#9BAABD;cursor:pointer;display:flex;align-items:center;border-left:1px solid var(--panel-border);transition:color 0.2s; }
.lp-eye:hover { color:var(--navy); }

.lp-error-msg { color:var(--error);font-size:0.73rem;margin-top:5px;display:flex;align-items:center;gap:4px;animation:shake 0.3s ease; }

.lp-action-row { display:flex;align-items:center;justify-content:space-between;margin-top:0.5rem;gap:1rem; }
.lp-action-row-end { justify-content:flex-end; }

.lp-submit { padding:11px 28px;background:linear-gradient(90deg,var(--navy),var(--navy-light));color:#fff;font-size:0.88rem;font-weight:700;font-family:'Outfit',sans-serif;letter-spacing:0.05em;border:none;border-radius:10px;cursor:pointer;position:relative;overflow:hidden;transition:transform 0.2s,box-shadow 0.2s,filter 0.2s;box-shadow:0 4px 18px rgba(24,67,129,.35);display:flex;align-items:center;gap:6px;min-width:170px;justify-content:center; }
.lp-submit:hover:not(:disabled) { transform:translateY(-2px);box-shadow:0 8px 26px rgba(24,67,129,.45);filter:brightness(1.06); }
.lp-submit:disabled { opacity:0.7;cursor:not-allowed; }
.lp-submit::after { content:'';position:absolute;top:0;left:-75%;width:50%;height:100%;background:linear-gradient(90deg,transparent,rgba(255,255,255,0.22),transparent);transform:skewX(-20deg); }
.lp-submit:hover::after { animation:shimmer 0.6s ease forwards; }
@keyframes shimmer { to{left:125%} }

.lp-btn-spinner { display:inline-block;width:16px;height:16px;border:2px solid rgba(255,255,255,0.4);border-top-color:#fff;border-radius:50%;animation:spin 0.7s linear infinite; }
@keyframes spin { to{transform:rotate(360deg)} }

/* Success card */
.lp-success-card { display:flex;flex-direction:column;align-items:center;text-align:center;padding:3rem 2rem;gap:1.1rem; }
.lp-success-ring { position:relative;width:86px;height:86px; }
.lp-success-ring::before { content:'';position:absolute;inset:-4px;border-radius:50%;background:conic-gradient(var(--navy),var(--navy-light),var(--navy));animation:spin-ring 2s linear infinite; }
.lp-success-icon { position:relative;width:86px;height:86px;border-radius:50%;background:#EAF1FB;border:1px solid #C7D6EC;color:var(--success);font-size:2rem;display:flex;align-items:center;justify-content:center;z-index:1;animation:pop-in 0.5s cubic-bezier(0.34,1.56,0.64,1) both; }
@keyframes pop-in { from{transform:scale(0);opacity:0} to{transform:scale(1);opacity:1} }
.lp-success-title { font-size:1.5rem;font-weight:800;color:var(--navy); }
.lp-success-sub   { color:var(--text-muted);font-size:0.88rem; }
.lp-spinner-bar { width:160px;height:3px;border-radius:2px;background:#E7ECFB;overflow:hidden; }
.lp-spinner-bar::after { content:'';display:block;height:100%;width:40%;border-radius:2px;background:linear-gradient(90deg,var(--navy),var(--navy-light));animation:bar-sweep 1.5s ease infinite; }
@keyframes bar-sweep { 0%{transform:translateX(-100%)} 100%{transform:translateX(350%)} }

.lp-footer { position:relative;z-index:10;display:flex;justify-content:space-between;align-items:center;padding:0.6rem 2rem;background:linear-gradient(160deg,var(--navy),var(--navy-light) 100%);border-top:1px solid rgba(255,255,255,0.08);font-size:0.72rem;color:rgba(255,255,255,0.55);letter-spacing:0.04em;flex-wrap:wrap;gap:0.25rem; }
.lp-footer-brand { color:#8FB4E3;font-weight:700; }

@media (max-width:600px) {
  .lp-header{padding:0.5rem 1rem}
  .lp-hname{font-size:0.75rem}
  .lp-form{padding:0.5rem 1.25rem 1.5rem}
  .lp-interface-tag{display:none}
}
`;
